import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { Carousel } from 'antd'
import { createStyles } from 'antd-style'
import { chunk } from 'lodash'

import { queryTradeSessionMallPageApi } from '@eastcoal/api/trade/tradeSession/queryTradeSessionMallPage'

import { AuctionDetailAuthenticator } from '@eastcoal/shared/components/AuctionDetailAuthenticator'

import { TradeSessionCarouselProps } from './interface'
import { TradeSessionItem } from './Item'

const useStyles = createStyles(
  ({ token }, props: { columns: number; rows: number }) => ({
    panel: {
      display: 'grid',
      gridTemplateColumns: `repeat(${props.columns},1fr)`,
      gridTemplateRows: `repeat(${props.rows},1fr)`,
      gap: token.paddingSM,
      height: 428
    }
  })
)

export const TradeSessionCarousel = ({
  types,
  kindCodes,
  columns,
  rows
}: TradeSessionCarouselProps) => {
  // 每页的大小
  const perPageSize = columns * rows
  const { data } = useRequest(
    () =>
      queryTradeSessionMallPageApi(
        {
          types,
          kindCodes,
          current: '1',
          pageSize: `${perPageSize * 2}`
        },
        {
          silence: true
        }
      ),
    {
      manual: false,
      retryCount: 5,
      retryInterval: 1000
    }
  )

  const { styles } = useStyles({ columns, rows })

  const panels = useMemo(
    () =>
      chunk(data?.records, perPageSize).map((items, index) => (
        <div key={index}>
          <div className={styles.panel}>
            {items.map(item => (
              <TradeSessionItem key={item.bizId} data={item} />
            ))}
          </div>
        </div>
      )),
    [data, perPageSize, styles.panel]
  )

  return (
    <AuctionDetailAuthenticator>
      <Carousel
        draggable
        pauseOnHover
        autoplaySpeed={10000}
        dotPlacement='bottom'
        dots={false}
        fade={false}
      >
        {panels}
      </Carousel>
    </AuctionDetailAuthenticator>
  )
}
